import api from './axios';

export const getUserFonts = async () => {
  const response = await api.get('/user-fonts');
  return response.data;
};

export const uploadUserFont = async (fontFile, fontName, licenseAgreed) => {
  const formData = new FormData();
  formData.append('font', fontFile);
  formData.append('fontName', fontName);
  formData.append('licenseAgreed', licenseAgreed ? 'true' : 'false');
  
  const response = await api.post('/user-fonts', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const deleteUserFont = async (fontId) => {
  const response = await api.delete(`/user-fonts/${fontId}`);
  return response.data;
};
